import badwords from './offensive-words.data';

interface UserField {
	name: string;
	value: string;
}

export const OFFENSIVE_LANGUAGE_MESSAGE = 'Please remove offensive language';

const escapeRegExp = (value: string) => value.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);

const containsOffensiveWord = (value: string, word: string) => {
	const escapedWord = escapeRegExp(word.toLocaleLowerCase());
	return new RegExp(`(^|[^a-z0-9])${escapedWord}([^a-z0-9]|$)`, 'i').test(value.toLocaleLowerCase());
};

export const unacceptableInputs = (inputs: UserField[]) => {
	return inputs
		.filter((input) => badwords.some((word) => containsOffensiveWord(input.value, word)))
		.map((input) => input.name);
};

export const withOffensiveWords = (value: string) => {
	return unacceptableInputs([{ name: 'value', value }]).length > 0;
};
